import { NO_IMAGE_URL } from '../../../../../constants/images';
import { type ContentComponent, type SalesCategoryContent } from '../../../../../types/construct.types';
import { type SaleCategoriesItem } from '../../../../../types/home.types';
import { HomeCarousel } from '../../../../home-components/home-carousel/home-carousel.component';

export const SalesCategoryHandler: ContentComponent<SalesCategoryContent> = ({
	content: {
		fields: { sales }
	}
}) => {
	// TODO: EFDC-36937 - HomeCarousel is tightly coupled to GraphQL fragment types. Once the migration is complete,
	// refactor HomeCarousel to consume construct types directly and remove the fragment dependencies.
	const items: SaleCategoriesItem[] = sales.items.map(({ fields: { image, title, subtitle, link } }) => ({
		__typename: 'HomePageSaleCategoriesItem' as const,
		title: title ?? '',
		subtitle: subtitle ?? '',
		image: {
			id: image.image?.id ?? NO_IMAGE_URL,
			imageType: image.image?.imageType ?? 'private',
			description: image.image?.description ?? '',
			lowQualityPlaceholder: image.image?.lowQualityPlaceholder ?? ''
		},
		trackingLink: {
			name: 'Link',
			url: link.linkUrl,
			tracking: link.trackingCode ?? ''
		}
	}));

	return <HomeCarousel items={items} automationHook="carousel-top-category-swipe" navigationVerticalPosition={-40} />;
};
